/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdhiwi_Goethe12Inputs */

const en__field_enum_sdhiwi_goethe12 = /** @type {(inputs: _Field_Enum_Sdhiwi_Goethe12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrende/r / Wiss. Mitarb. der Goethe-Universität`)
};

const de__field_enum_sdhiwi_goethe12 = /** @type {(inputs: _Field_Enum_Sdhiwi_Goethe12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrende/r / Wiss. Mitarb. der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Lehrende/r / Wiss. Mitarb. der Goethe-Universität" |
*
* @param {_Field_Enum_Sdhiwi_Goethe12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdhiwi_goethe12 = /** @type {((inputs?: _Field_Enum_Sdhiwi_Goethe12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdhiwi_Goethe12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdhiwi_goethe12(inputs)
	return de__field_enum_sdhiwi_goethe12(inputs)
});
export { _field_enum_sdhiwi_goethe12 as "_field_enum_SDHIWI_GOETHE" }